import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMottakertyper as getMottakertyperAction } from "../../../../actions/mottakertyperActions";
import { getGridTableRowData } from "../../../../selectors/miljogebyrMottakerAvMiljogebyrSelector";
import GridTable from "../../GridTable";

export default function MottakerAvMiljogebyrContainer() {
  const gridTableRowData = useSelector(getGridTableRowData);
  const mottakertyper = useSelector((state) => state.mottakertyper);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!mottakertyper.length) dispatch(getMottakertyperAction());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section>
      <div className="detalj-ileggelse-header-wrapper">
        <h2>Mottaker av miljøgebyr</h2>
      </div>
      <div>
        <GridTable
          name="mottakerAvMiljogebyr"
          rows={gridTableRowData}
          oneColoredGridTable
        />
      </div>
    </section>
  );
}
